import getCustomDimensions from './customDimensions';
import getContentGroups from './contentGroups';
import getPageViewData from './getPageViewData';
import { setCustomDimension, sendPageView, setContentGroup, setEvent, setLinkedDomain } from './actions';

export default function processGaPageLoad({
    state,
    dispatch,
    analytics,
    location,
}) {
    const { theme } = state;

    dispatch(setLinkedDomain({
        theme,
        state,
        location,
    }));

    getCustomDimensions({
        theme,
        analytics,
        state,
    })
        .forEach(dimension => {
            dispatch(setCustomDimension(dimension));
        });

    getContentGroups({
        analytics,
        state,
    })
        .forEach(contentGroup => {
            dispatch(setContentGroup(contentGroup));
        });

    const pageViewEvent = getPageViewData({
        location,
        theme,
    });
    dispatch(sendPageView(pageViewEvent));

    if (analytics.getEventData) {
        analytics.getEventData({
            state,
            theme,
        })
            .forEach(event => {
                dispatch(setEvent(event));
            });
    }
}
